import Mustache from "mustache";
import { purify } from "$json/lib/escape.js";
import { converter } from "$md-converter";
import { bb } from "$json";
import { intercept } from "$blank";
/* info-template:
 *
 * Render infolinks according to Mustache template
 *
 * @dependencies: Mustache
 *
 * Author: Niels Giesen
 * Copyright 2016 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  $(function () {
    var tmpl = $("#bb-p-info-template").html(),
      container = document.getElementById("bb-p-info-template-container");

    Mustache.tags = ["[[", "]]"];

    intercept(container);

    $(doc).on("bb:postHandleData", function (event, data) {
      var html, sources, nodeinfo;
      if (container && tmpl && data && data.informationsources) {
        if (data.informationsources.length) {
          nodeinfo = $.map(data.informationsources, function (source) {
            if (
              source.description.substring(9, 0) === "Nodeinfo:" &&
              !source.isurl
            ) {
              return {
                isurl: false,
                description: source.description.substring(9),
                content:
                  (converter && converter.makeHtml(source.content)) ||
                  source.content
              };
            }
          });
          sources = $.map(data.informationsources, function (source) {
            var xss = source.isurl && bb.URL.isJS(source.content);
            return {
              isurl: source.isurl && !xss,
              description: source.description,
              content: xss
                ? bb.URL.JSAlertMessage
                : source.isurl
                  ? bb.escapeHTML(source.content)
                  : (converter &&
                      converter.makeHtml(bb.escapeHTML(source.content))) ||
                    source.content
            };
          });
          html = Mustache.render(tmpl, {
            sources: sources,
            nodeinfo: nodeinfo
          });
        } else {
          html = "";
        }
        container.innerHTML = purify(html);
        nodeinfo && nodeinfo.length > 0
          ? bb.Mode.set("hasNodeinfo")
          : bb.Mode.unset("hasNodeinfo");
      }
    });
  });
})(jQuery, window, document);
